export const UNIDENTIFIED_STAGE = 'Unidentified-Stage';
export const EXIT_ACTION = 'Exit Case';
export const EXIT_CASE_LIST = [
  { id: '15', viewCode: 'EC', value: EXIT_ACTION, text: EXIT_ACTION, color: '#007dc3' }
];
export const OP1_REASON_CODE = 'OP1';
export const WEX_QUEUE_ID = 80;
export const CASE_HEADER_CONTAINER = 'case-header-container';
export const CASE_HEADER_INNER =  'case-header';
export const MAIN_CONTENT_HEADER = 'main-content--header';
export const CASELANDING_PATH = "caselanding/";
export const AMEX_QUEUE = 71;